export default __webpack_public_path__ + "static/media/logo.9d95975d.png";